import { SubTaskDetailsPanelWebComponent } from './component/SubTaskDetailsPanelWebComponent';
import { WEB_COMPONENT_SUBTASKS_DETAILS_PANEL } from '../../webcomponents.constants';
/**
 * The side-panel component for displaying subtask details
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468358/Tasks+Page
 */
export { SubTaskDetailsPanelWebComponent };

window.customElements.define(WEB_COMPONENT_SUBTASKS_DETAILS_PANEL, SubTaskDetailsPanelWebComponent);
